import type { IStockService } from './IStockService';
import type { PagedResponse } from '../dto/PagedResponse';
import type { StockLevel } from '../dto/StockLevel.dto';
import type { StockOperation } from '../dto/StockOperation.dto';
import type { GroupedStock } from '../dto/GroupedStock.dto';
import type { StockHistoryParams } from '../http/StockHistoryParams';
import { StockListParams } from '../http/StockListParams';
import type { StockGroupedListParams } from '../http/StockGroupedListParams';
import { QueryBuilder } from '../http/QueryBuilder';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { fetchWithAuth } from '../../../utils/fetch/FetchWithAuth';
 
const BASE = '/api/warehouse/stock';
 
export class StockService implements IStockService {
    async query(params?: StockListParams): Promise<PagedResponse<StockLevel>> {
        return fetchWithAuth(
            `${BASE}${QueryBuilder.from(params).build()}`,
            { method: 'GET' }
        );
    }
 
    async queryGrouped(params?: StockGroupedListParams): Promise<PagedResponse<GroupedStock>> {
        return fetchWithAuth(
            `${BASE}/grouped-by-product${QueryBuilder.from(params).build()}`,
            { method: 'GET' }
        );
    }
 
    async getHistory(params?: StockHistoryParams): Promise<PagedResponse<StockOperation>> {
        return fetchWithAuth(
            `${BASE}/history${QueryBuilder.from(params).build()}`,
            { method: 'GET' }
        );
    }
}
 
